import { motion, useScroll, useSpring } from "framer-motion";

/**
 * ScrollProgressBar — thin gold hairline fixed at the top of every page.
 * Fills left→right as the user scrolls, with a spring-smoothed transform
 * so it feels like a physical indicator rather than a raw meter.
 */
export default function ScrollProgressBar() {
  const { scrollYProgress } = useScroll();
  const smooth = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 26,
    restDelta: 0.001,
  });

  return (
    <motion.div
      aria-hidden
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 z-[9999] pointer-events-none"
      style={{
        height: "2px",
        transformOrigin: "0 0",
        scaleX: smooth,
        background:
          "linear-gradient(90deg, rgba(198,168,124,0.4) 0%, #E8D9C5 40%, #C6A87C 60%, rgba(232,217,197,0.4) 100%)",
        boxShadow: "0 0 12px rgba(232,217,197,0.55)",
      }}
    />
  );
}
